module.exports = __webpack_public_path__ + "img/document-icon.dc0086ff.svg";